export interface HeaderNavItem {
    id: string;
    labelKey: string;
    route: string;
    exact?: boolean;
    activeRoutes?: string[];
}

export const HEADER_NAV: ReadonlyArray<HeaderNavItem> = [
    {
        id: 'blanks',
        labelKey: 'nav.blanks',
        route: '/blanks',
        exact: true,
        activeRoutes: ['/blanks', '/job-form'],
    }
];

export interface HeaderUserMenuItem {
    id: string;
    labelKey: string;
    icon: string;
    action:
        | { kind: 'route'; route: string }
        | { kind: 'sign-out' }
        /** No-op placeholder — used for menu items whose target screen
         * isn't built yet. Clicking simply closes the dropdown. */
        | { kind: 'noop' };
    /** Show a chevron on the right (used by Sign out to mirror the design). */
    showChevron?: boolean;
}

export const HEADER_USER_MENU: ReadonlyArray<HeaderUserMenuItem> = [
    {
        id: 'users',
        labelKey: 'nav.users',
        icon: 'svg/user.svg',
        action: { kind: 'route', route: '/users' },
    },
    {
        id: 'settings',
        labelKey: 'nav.settings',
        icon: 'svg/settings.svg',
        action: { kind: 'route', route: '/settings' },
    },
    {
        id: 'sign-out',
        labelKey: 'header.signOut',
        icon: 'svg/signout.svg',
        action: { kind: 'sign-out' },
        showChevron: true,
    },
];
